export const getInitialForm = () => {
  return {
    isGateway: true,
    paymentType: 'POSTPAY',
  };
};
